import axios from 'axios';
import { ls } from '../localStorage';
import jwt_decode from "jwt-decode";
import { StatusCodes } from 'http-status-codes';

const LOGIN_URL=process.env.REACT_APP_LOGIN_URL+'/login/v3.0';
const UNIT_PLAN_NJS_URL=process.env.REACT_APP_UNIT_PLAN_NJS_URL+'/unit-plan/v4.0';
const SKILLS_URL=process.env.REACT_APP_SKILLS_URL+'/skills';
const QUIZZES_PLAY_URL=process.env.REACT_APP_QUIZZES_PLAY_URL+'/quizPlay/v3.0';
const ACTIVITIES_PLAY_URL=process.env.REACT_APP_ACTIVITIES_PLAY_URL+'/activities/v3.0';
const USER_NJS_API_URL=process.env.REACT_APP_USER_NJS_URL+'/users';
const SMARTSHEETS_PLAY_URL=process.env.REACT_APP_SMARTSHEETS_PLAY_URL+'/smartSheetPlay/v3.0';
const USERS_URL=process.env.REACT_APP_USERS_URL+'/users/v3.0';
const CORES_URL=process.env.REACT_APP_CORES_URL+'/cores/v3.0';
const PLAY_NJS_URL=process.env.REACT_APP_PLAY_URL+'/play-service/v4.0';
const EMAIL_API_URL = process.env.REACT_APP_EMAIL_URL; 

const checkIfTokenRefreshNeeded = async () => {
    let token =ls.getToken();
    let decode_token:any =jwt_decode(token)
    var currentTimeSeconds = Math.round(+new Date() / 1000);
    // console.log(decode_token);
    if (decode_token.exp < currentTimeSeconds) {
      try {
        // console.log("Token has expired");
        let res= await apis._refreshToken();
        // console.log(res);
        if(res.status===StatusCodes.OK)
        {
            token = res.data.token;
            ls.setToken(token);
        }
      }
      catch (e) {
        console.log("Unable to refresh token" + e);
      }
    }
}

axios.interceptors.request.use(
    async req => {
      await checkIfTokenRefreshNeeded();
      req.headers = {
        'x-access-token': ls.getToken(),
        'x-access-db': ls.getDBToken()
      }
      return (await req);
    },
    (error) => {
        if (error?.response) {
            return error.response.data;
        }
        else if (error?.request) {
            return error.request;
        }
    }
);

  axios.interceptors.response.use(  
        function (response) {
            if(response?.data?.token)
             {
                 ls.setToken(response?.data?.token);
             }
            if(response.status>=200 && response.status<300){
            //  console.log(`status 2xx`, response);
            }
          return response;
        },
        function (error) {
            if (error?.response) {
               console.log("error",error.response)
               if(error.response.status!==404){
                callAgain(error.response.config,3)
               } 
                return error.response.data;
            }
            else if (error?.request) {
                return error.request;
            }  
          return Promise.reject(error);
        }
      );

      async function callAgain(requests:any, maxRetries = 3) {
        // console.log("Retrying API requests:", requests);
      
        async function makeRequest(config:any, retryCount:number) {
            // console.log("config should be here : ",config)
          try {
            const uninterceptedAxiosInstance:any = axios.create();
            console.log(`Retrying (${retryCount} attempts left)...`);
            const response = await uninterceptedAxiosInstance({
                          method: config.method,
                          url: config.url,
                          headers: config.headers,
                          data:config.data,
                        })
            // console.log("Retried: status", response);
          } catch (error) {
            console.error('Retried: Error', error);   
            if (retryCount > 1) { 
               await new Promise((resolve) => setTimeout(resolve, 1000)); // Wait for 1 second before retrying
               await callAgain(config,retryCount - 1);
             } else {
               console.log("Max retries reached. Unable to get API : ",config);
             }
          }
        }
          await makeRequest(requests, maxRetries); 
      }
      
const apis ={
_initializeSession : async (token:string)=>{
    let isOffLineSchool = false;
    let isMobileAPP =false;
    ls.setToken(token);
    const uninterceptedAxiosInstance = axios.create();
    const res = await uninterceptedAxiosInstance.get(`${LOGIN_URL}/session/init/${token}/${isOffLineSchool}/${isMobileAPP}?${new Date().toISOString()}`)
    .catch(function (error) {

        if (error.response) {
            return error.response.data;
        }
        else if (error.request) {
            return error.request;
        }
    });
    return res; 
},
_refreshToken : async ()=>{
    let isMobileAPP =false;
    const uninterceptedAxiosInstance = axios.create();
    const res = await uninterceptedAxiosInstance.get(`${LOGIN_URL}/token/refresh/${isMobileAPP}`,{ headers: {'x-access-token': ls.getToken() }})
    .catch(function (error) {

        if (error.response) {
            return error.response.data;
        }
        else if (error.request) {
            return error.request;
        }
    });
    return res; 
},
_refreshSession:async ()=>{
    const res = await axios.get(`${LOGIN_URL}/session/refresh/false`);
    return res; 
},
_resetPassword:async (data:{password:string,user_id:string})=>{
    const res = await axios.put(`${USERS_URL}/resetPassword`,data);
    return res; 
},
_getAvatars:async (data:any)=>{
    const res = await axios.post(`${USERS_URL}/avatars`,data);
    return res; 
},
_getDailyGoalList:async (data:any)=>{
    const res = await axios.post(`${UNIT_PLAN_NJS_URL}/daily-goal/list`,data);
    return res; 
},

_getDailyGoal:async (id:string)=>{
    const res = await axios.get(`${UNIT_PLAN_NJS_URL}/daily-goal/user/${id}`);
    return res; 
},


_questionsDetails:async (q_ids:any, countryCode:string)=>{
    const payload = {
        ques_ids: q_ids,
        country_code: countryCode === "IN" ? "IN" : "US"
    }
    const res = await axios.post(`${UNIT_PLAN_NJS_URL}/sessions/questions`,payload);
    // console.log("question details",res)
    return res; 
},

_questionsTransactionsExist:async (session_id: string,user_id:string,timeSlot:string,data:any)=>{
    const res = await axios.post(`${UNIT_PLAN_NJS_URL}/question-txns/exist/${user_id}/${session_id}/${timeSlot}`,data);
    // console.log("question transactions exists",res)
    return res; 
},

_questionsTransactions:async (data:any)=>{
    const res = await axios.post(`${UNIT_PLAN_NJS_URL}/question-txns`,[data]);
    // console.log("question transactions",res)
    return res; 
},

_fetchSessionStatus: async(userID:string, sessionID:string)=>{
    const res = await axios.get(`${UNIT_PLAN_NJS_URL}/session-status/summary/${userID}/${sessionID}`)
    return res;
},

_updateClassWorkSessionStatus:async(
    session_id:string, 
    user_id:string,  
    timeSlot:string, 
    data:{
        category: string,
        status: string,
        max_score: number,
        score: number,
        session_status: string,
        time_taken: number,
        classwork_status: string,
    }) =>{
    const res = await axios.post(`${UNIT_PLAN_NJS_URL}/session-status/classwork/${user_id}/${session_id}/${timeSlot}`, data);
    return res;
  },

_updateHomeWorkSessionStatus:async(
    session_id:string, user_id:string, timeSlot:string, 
    data:{
        category: string,
        status: string,
        max_score: number,
        score: number,
        time_taken: number,
        session_status: string,
        homework_id: string,
        homework_status: string,
    }) =>{
    const res = await axios.post(`${UNIT_PLAN_NJS_URL}/session-status/homework/${user_id}/${session_id}/${timeSlot}`, data);
    return res;
  },

_setDailyGoal:async (data:any)=>{
    const res = await axios.post(`${UNIT_PLAN_NJS_URL}/daily-goal/user`,data);
    return res; 
},

_saveQuestionResponse : async (data:any)=>{
    const res = await axios.post(`${PLAY_NJS_URL}/adaptive-practice/question`,data);
    return res; 
},

// HOTS has its own endpoint: the adaptive one is built around a skill and requires lo_id,
// isChallenge, isSafeZone and current_level, none of which a HOTS attempt has.
// Adaptive quiz builder (teacher). The unit plan is the same one teacher-web loads for its own
// pickers; the builder reads it here so the whole Module -> Sub-topic -> Skill flow lives in play-ui.
_getUnitPlanForTeacher: async (classroom_id:string)=>{
    const res = await axios.post(`${SKILLS_URL}/v3.0/fetchUnitPlanForActive`,{classroom_id});
    return res;
},

_createAdaptiveQuiz: async (data:any)=>{
    const res = await axios.post(`${PLAY_NJS_URL}/adaptive-quiz/create`,data);
    return res;
},

_updateAdaptiveQuiz: async (data:any)=>{
    const res = await axios.put(`${PLAY_NJS_URL}/adaptive-quiz/update`,data);
    return res;
},

_viewAdaptiveQuiz: async (quiz_id:string)=>{
    const res = await axios.post(`${PLAY_NJS_URL}/adaptive-quiz/view`,{quiz_id});
    return res;
},

// A student's sitting at a quiz. Opened once, handed over as it goes, submitted once.
//
// `fetch` opens the sitting and answers with only the questions still to play, the seconds left and
// the session number to stamp this sitting with. `progress` hands over what has been done - and with
// an empty `answers` it is the heartbeat, which is what lets the clock be charged when a device dies
// without saying goodbye. `submit` moves the whole attempt into the database.
// A STUDENT reading their OWN answers, from their quiz list. No id is sent - the server takes it from
// the token, so a student can only ever ask for their own. Answers in the same shape as the teacher's
// call below, which is what lets one screen show both.
_fetchMyAdaptiveQuizAttempt: async (quiz_id:string)=>{
    const res = await axios.post(`${PLAY_NJS_URL}/adaptive-quiz/report/student/attempt`,{quiz_id});
    return res;
},

// The quizzes this student has attempted - the list their report screen is built from.
_fetchMyAttemptedAdaptiveQuizzes: async ()=>{
    const res = await axios.get(`${PLAY_NJS_URL}/adaptive-quiz/report/student/attempted`);
    return res;
},

// A TEACHER reading one student's finished attempt, from the classroom analytics screen. The teacher's
// own token is used, so this is the teacher-scoped report endpoint - not /student/fetch, which would
// refuse them. It answers with the quiz's frozen questions AND what the student answered, which is
// everything the review needs; nothing is written and no sitting is opened.
_fetchAdaptiveQuizAttemptForTeacher: async (quiz_id:string, user_id:string)=>{
    const res = await axios.post(`${PLAY_NJS_URL}/adaptive-quiz/report/teacher/user-wise`,{quiz_id,user_id});
    return res;
},

_fetchAdaptiveQuizForStudent: async (quiz_id:string)=>{
    const res = await axios.post(`${PLAY_NJS_URL}/adaptive-quiz/student/fetch`,{quiz_id});
    return res;
},

// The SAME hand-over as _saveAdaptiveQuizProgress, for a tab or a phone being CLOSED.
//
// `keepalive` is the whole difference: the browser promises to finish this after the page is gone,
// where an axios call is cancelled along with the page and the student's last seconds are lost. Not
// sendBeacon, which cannot carry the two headers these calls are authenticated with - and not the
// interceptor either, since there is no request to intercept by then, so the headers are set here.
//
// It lives beside the other calls so the base URL and the auth headers have one definition, and it
// follows PLAY_NJS_URL wherever that points.
//
// Nothing is lost if it never arrives - the server charges the time from its own clock either way.
// What it buys is the exact figure rather than one rounded up to the last heartbeat.
_handOverAdaptiveQuizOnExit: (data:any)=>{
    try {
        void fetch(`${PLAY_NJS_URL}/adaptive-quiz/student/progress`,{
            method: 'POST',
            keepalive: true,
            headers: {
                'Content-Type': 'application/json',
                'x-access-token': ls.getToken(),
                'x-access-db': ls.getDBToken(),
            },
            body: JSON.stringify(data),
        });
    } catch (error) {
        console.log('quiz player: could not hand over on the way out', error);
    }
},

_saveAdaptiveQuizProgress: async (data:any)=>{
    const res = await axios.post(`${PLAY_NJS_URL}/adaptive-quiz/student/progress`,data);
    return res;
},

_submitAdaptiveQuiz: async (data:any)=>{
    const res = await axios.post(`${PLAY_NJS_URL}/adaptive-quiz/student/submit`,data);
    return res;
},

_saveHotsQuestionResponse : async (data:any)=>{
    const res = await axios.post(`${PLAY_NJS_URL}/adaptive-practice/hots-question`,data);
    return res;
},

_saveQuestionResponseForAdaptiveSession: async (data:any)=>{
    const res = await axios.post(`${PLAY_NJS_URL}/adaptive-session/question/`,data);
    return res; 
},

_getAdaptiveSessionStatus: async (user_id:string, session_id:string)=>{
    const res = await axios.get(`${PLAY_NJS_URL}/adaptive-session/status/${user_id}/${session_id}`);
    return res; 
},
_getAdaptiveSessionQuestion: async (userId: string, session_id: string) => {
        let filterData = {
            "filterList": [
                {
                    "columnName": "user_id",
                    "type": "filterId",
                    "value": [userId]
                },
                {
                    "columnName": "session_id",
                    "type": "filterId",
                    "value": [session_id]
                },
                {
                    "columnName": "type",
                    "type": "filerName",
                    "value": ["AdaptivePractice"]
                }
            ],
            "sortHeader": "createdAt",
            "sortDirection": "ASC",
            "page": 1,
            "limit": 1,
            "isPagination": false
        }
        const res = await axios.post(`${UNIT_PLAN_NJS_URL}/adaptive-practice/question/list/`,filterData);
        return res;
},
_getSkillStatus : async (data:any)=>{
    const res = await axios.post(`${UNIT_PLAN_NJS_URL}/adaptive-practice/skill/status/list`,data);
    return res; 
},
_getLastUserSummary : async (userId:string)=>{
  const data=  {
        "filterList": [
            {
                "columnName": "user_id",
                "type": "filterId",
                "value": [userId]
            }
        ],
        "sortHeader": "report_date",
        "sortDirection": "DESC",
        "page": 1,
        "limit": 1,
        "isPagination": true
    }
    const res = await axios.post(`${UNIT_PLAN_NJS_URL}/adaptive-practice/user/summary`,data);
    return res; 
},
_getDashboardSummary : async (id:string,unitPlanId:string,grade:number,isB2B:Boolean)=>{
    const res = await axios.get(`${UNIT_PLAN_NJS_URL}/adaptive-practice/student/dashboard-summary/${id}/${unitPlanId}/${grade}/${isB2B}`);
    return res; 
},
_getTodaysUserAchievements : async (uId:string)=>{
    const res = await axios.get(`${UNIT_PLAN_NJS_URL}/adaptive-practice/daily-user-achievements/${uId}`);
    return res; 
},
_getDailyUserAchievements : async (data:any)=>{
    const res = await axios.post(`${UNIT_PLAN_NJS_URL}/adaptive-practice/daily-user-achievements`,data);
    return res; 
},
_getDailyQuestionList : async (data:any)=>{
    const res = await axios.post(`${UNIT_PLAN_NJS_URL}/adaptive-practice/question/list`,data);
    return res; 
},
_getBadges : async (userId:string)=>{
    const res = await axios.get(`${PLAY_NJS_URL}/user-badges`);
    return res; 
},
_setBadgeAchievement : async (data:[])=>{
    const res = await axios.put(`${PLAY_NJS_URL}/user-badges/user-badge-achievement`,{badgeAchievement:data});
    return res; 
},
_getClassroomsWallOfFame : async (data:{classroom_id:string,isWeekly: boolean})=>{
    const res = await axios.post(`${UNIT_PLAN_NJS_URL}/classrooms/wall-of-fame`,data);
    return res; 
},
_getActiveTopicList : async (data:any)=>{
    const res = await axios.post(`${SKILLS_URL}/v4.0/topics/active`,data);
    return res; 
},
_getActiveQuizzes : async ()=>{
    const res = await axios.get(`${SKILLS_URL}/v3.0/fetchActiveQuizzesOfStudent`);
    return res; 
},
_getLOsTopicWise: async (data:any)=>{
    const res = await axios.post(`${SKILLS_URL}/v4.0/fetchLOsTopicWise`,data);
    return res; 
},
_getLOContentForStudent : async (data:any)=>{
    const res = await axios.post(`${SKILLS_URL}/v4.0/fetchLOContentForStudent`,data);
    return res; 
},
_getActivityInfo : async (data:any)=>{
    const res = await axios.post(`${SKILLS_URL}/v4.0/fetchActivityInfo`,data);
    return res; 
},
_isSmartSheetTaken : async (data:any)=>{
    // {"smart_sheet_id":"5c9486124c164b0d4ca6d2aa","country_code":"IN"}
    const res = await axios.post(`${SMARTSHEETS_PLAY_URL}/isSmartSheetTaken/`,data);
    return res; 
},
_isRatedSmartsheet : async (data:any)=>{
    const res = await axios.post(`${SMARTSHEETS_PLAY_URL}/isRatedSmartsheet/`,data);
    return res; 
},
_fetchSmartSheet : async (data:any)=>{
    const res = await axios.post(`${SMARTSHEETS_PLAY_URL}/fetchSmartSheet/`,data);
    return res; 
},
_saveSmartSheetResult : async (data:any)=>{
    const res = await axios.post(`${SMARTSHEETS_PLAY_URL}/saveResult/`,data);
    return res; 
},
_saveRatesSmartsheet : async (data:any)=>{
    const res = await axios.post(`${SMARTSHEETS_PLAY_URL}/ratesSmartsheet/`,data);
    return res; 
},
_isQuizTaken : async (data:any)=>{
    const res = await axios.post(`${QUIZZES_PLAY_URL}/isQuizTaken/`,data);
    return res; 
},
_fetchQuiz : async (data:any)=>{
    const res = await axios.post(`${QUIZZES_PLAY_URL}/fetchQuiz/`,data);
    return res; 
},
_saveQuizResult : async (data:any)=>{
    const res = await axios.post(`${QUIZZES_PLAY_URL}/saveResult/`,data);
    return res; 
},
_getActivityInfoForStudent : async (data:any)=>{
    const res = await axios.post(`${ACTIVITIES_PLAY_URL}/fetchActivityInfoForStudent/`,data);
    return res; 
},
_setCurrentTopic : async (uId:string,data:any)=>{
    const res = await axios.put(`${USER_NJS_API_URL}/v5.0/topic/${uId}`,data);
    return res; 
},
_setAvatar : async (uId:string,data:{level:number})=>{
    const res = await axios.put(`${USER_NJS_API_URL}/v5.0/avatar/${uId}`,data);
    return res; 
},
_getActivityStatus : async (data:any)=>{
    const res = await axios.post(`${ACTIVITIES_PLAY_URL}/isActivityCompleted/`,data);
    return res; 
},
_getQuarterlyReport: async (classRoomId:string,month:number,year:number)=>{
    const res=await axios.get(`${UNIT_PLAN_NJS_URL}/report/quarterly/student/classroomWise/${year}/${month}/${classRoomId}`)
    return res;
},
_getMentalMathLevel: async (data:{classroom_id?:string,lo_id:string,user_id:string})=>{
    const res=await axios.post(`${PLAY_NJS_URL}/mental-math/level`,data);
    return res;
},
_getMentalMathHighScore: async (loId:string, qId:string)=>{
    const res=await axios.get(`${PLAY_NJS_URL}/mental-math/high-score/${loId}/${qId}`);
    return res;
},
_saveMentalMathQuestions: async (data:{ questions:any[], stars: number })=>{
    const res=await axios.post(`${PLAY_NJS_URL}/mental-math/question`,data);
    return res;
},
_getTodaysSmartXPSummary: async (data: {
    user_id: string,
    lo_id: string,
    classroom_id?: string,
    question_id?: string,
}) => {
    const res = await axios.post(`${PLAY_NJS_URL}/smart-xp-sessions/today/skill-summary`, data);
    return res;
 },
_sendBugReport : async (data:any) => {    
    const response = await axios.post(EMAIL_API_URL + '/v2.0/email/bugReportMail', data);
    return response.data; 
 },
 _setSessionTxnData: async (key: string, data: any) => {
    const res = await axios.put(`${UNIT_PLAN_NJS_URL}/sessions-txns/redisData/${key}`, data);
    return res;
},
_getSessionTxn: async (key: string) => {
    const res = await axios.get(`${UNIT_PLAN_NJS_URL}/sessions-txns/redisData/${key}`);
    return res;
},
_getAllSessionTxn: async (key: string, type: string) => {
    const res = await axios.get(`${UNIT_PLAN_NJS_URL}/sessions-txns/redisData/${key}/${type}`);
    return res;
}
}
export default apis;